/**
 * @param {string} mobile
 * @returns {Boolean}
 */
 export function validMobile(value) {
    return /^1[23456789]\d{9}$/.test(value)
 }

 /**
 * 验证十进制数字
 */
  export function validNumber(value) {
  return /^[\+-]?(\d+\.?\d*|\.\d+|\d\.\d+e\+\d+)$/.test(value)
}


 /**
 * 验证日期格式
 * @param {string} date
 * @returns {Boolean}
 */
export function validDate(value) {
  if (!value) return false
  // 判断是否数值或者字符串数值(意味着为时间戳)，转为数值，否则new Date无法识别字符串时间戳
  if (validNumber(value)) value = +value
  return !/Invalid|NaN/.test(new Date(value).toString())
}

 /**
 * @description 使用 ISO 7064:1983.MOD 11-2 算法进行校验身份证格式
 *  函数参数必须是字符串，因为二代身份证号码是十八位，
 *  而在javascript中，十八位的数值会超出计算范围，
 *  造成不精确的结果，导致最后两位和计算的值不一致，从而该函数出现错误。
 * @author wx
 * @param {string} idCard 身份证号
 * @return {Boolean}
 */
export function validateIDCardISO(idCard) {
   // 加权因子
   const weightFactor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
   // 校验码
   const checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
 
   // 英文转大写
   let code = idCard.toUpperCase()
   const last = code[17] //最后一位
 
   // 前17位
   const seventeen = code.substring(0, 17)
 
   // ISO 7064:1983.MOD 11-2
   // 判断最后一位校验码是否正确
   const arr = seventeen.split('')
   const len = arr.length
   let num = 0
   for (let i = 0; i < len; i++) {
     num = num + arr[i] * weightFactor[i]
   }
 
   // 获取余数
   const remainder = num % 11
   const lastNo = checkCode[remainder]
   /**
    * 格式的正则思路：
    * 第一位不可能是0
    * 第二位到第六位可以是0-9
    * 第七位到第十位是年份，所以七八位为19或者20
    * 十一位和十二位是月份，这两位是01-12之间的数值
    * 十三位和十四位是日期，是从01-31之间的数值
    * 十五，十六，十七都是数字0-9
    * 十八位可能是数字0-9，也可能是X
    */
   const idCardPatter =
     /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/
 
   // 判断格式是否正确
   const format = idCardPatter.test(code)
 
   // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
   return last === lastNo && format ? true : false
 }


// WEBPACK FOOTER //
// ./src/utilsCloud/validate.js